// The browser's calendar day as YYYY-MM-DD.
//
// The backend runs TIME_ZONE=UTC, so its own "today" rolls over at 8 pm
// Eastern; anything that decides "overdue" or "due today" (the Today feed, the
// Practices task column and its overdue filter) sends this instead and the
// server buckets against it. NOT toISOString().slice(0, 10) — that is UTC too.
export default function localDay(d = new Date()) {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}
